/**
 * Search Filter Dropdown
 * Handles the functionality for the search results filter dropdown
 */
class SearchFilter extends HTMLElement {
  constructor() {
    super()
    this.filterButton = this.querySelector('#filterButton')
    this.filterDropdown = this.querySelector('#filterDropdown')
    this.isOpen = false
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (this.filterButton && this.filterDropdown) {
      this.init()
    }
  }

  init() {
    this.bindEvents()
  }

  bindEvents() {
    this.filterButton.addEventListener('click', this.handleButtonClick.bind(this))
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  }

  handleButtonClick(e) {
    e.stopPropagation()
    this.toggleDropdown()
  }

  handleDocumentClick(e) {
    if (!this.contains(e.target)) {
      this.closeDropdown()
    }
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown()
    } else {
      this.openDropdown()
    }
  }

  openDropdown() {
    this.isOpen = true
    this.filterDropdown.classList.remove('hidden')
    this.filterDropdown.classList.add('dropdown-open')
    this.filterDropdown.classList.remove('dropdown-close')

    // Add animation to dropdown items
    const items = this.filterDropdown.querySelectorAll('a')
    items.forEach((item, index) => {
      item.style.opacity = '0'
      item.style.transform = 'translateY(-10px)'
      setTimeout(() => {
        item.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
        item.style.opacity = '1'
        item.style.transform = 'translateY(0)'
      }, index * 50)
    })
  }

  closeDropdown() {
    if (!this.isOpen) return

    this.isOpen = false
    this.filterDropdown.classList.remove('dropdown-open')
    this.filterDropdown.classList.add('dropdown-close')

    // Animate dropdown items out
    const items = this.filterDropdown.querySelectorAll('a')
    items.forEach((item, index) => {
      item.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
      item.style.opacity = '0'
      item.style.transform = 'translateY(-10px)'
    })

    // Hide dropdown after animation
    setTimeout(
      () => {
        this.filterDropdown.classList.add('hidden')
      },
      this.prefersReducedMotion ? 100 : 300
    )
  }
}

if (!customElements.get('search-filter')) {
  customElements.define('search-filter', SearchFilter)
}
